'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _illustrationIcons = require('./illustration-icons');

var _illustrationIcons2 = _interopRequireDefault(_illustrationIcons);

var _presentationalIcons = require('./presentational-icons');

var _presentationalIcons2 = _interopRequireDefault(_presentationalIcons);

var _productIcons = require('./product-icons');

var _productIcons2 = _interopRequireDefault(_productIcons);

var _flagIcons = require('./flag-icons');

var _flagIcons2 = _interopRequireDefault(_flagIcons);

var _logoIcons = require('./logo-icons');

var _logoIcons2 = _interopRequireDefault(_logoIcons);

var _generic = require('./generic');

var _generic2 = _interopRequireDefault(_generic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({}, _generic2.default, _illustrationIcons2.default, _presentationalIcons2.default, _productIcons2.default, _flagIcons2.default, _logoIcons2.default);